import { Badge, Modal } from "flowbite-react";
import { useContext } from "react";
import { IAppContextState, AppContext } from "../../../App";
import { Link } from "react-router-dom";
import { BftiImageGallery } from "../../../components/image-gallery/bfti-gallery";

export const BftiModalData = () => {
  const { bftiModalState } = useContext<IAppContextState | any>(AppContext);
  const [isOpenBftiModal, setOpenBftiModal] = bftiModalState;
  return (
    <Modal
      size={"5xl"}
      position={"top-center"}
      show={isOpenBftiModal}
      onClose={() => setOpenBftiModal(false)}
    >
      <Modal.Header>BFTI - Bangladesh Foreign Trade Institute</Modal.Header>
      <Modal.Body>
        <div className="flex flex-wrap">
          <div className="md:w-[50%] w-full pe-2">
            <BftiImageGallery />
          </div>
          <div className="md:w-[50%] w-full ps-2 md:mt-0 mt-6 flex flex-col justify-between">
            <div>
              <h3 className="font-bold text-xl">
                Project name: <span className="text-teal-600">BFTI</span>
              </h3>
              <p className="mt-4 mb-2 text-md text-[15px]">Tech used:</p>
              <div className="flex flex-wrap">
                <Badge color="red" className="me-2 my-1">
                  HTML
                </Badge>
                <Badge color="gray" className="me-2 my-1">
                  javaScript
                </Badge>
                <Badge color="yellow" className="me-2 my-1">
                  jQuery
                </Badge>
                <Badge color="blue" className="me-2 my-1">
                  Bootstrap
                </Badge>
                <Badge color="pink" className="my-1">
                  SCSS
                </Badge>
              </div>
              <div className="mt-5 mb-2 ">
                <p className="font-semibold">Description:</p>
                <div className="text-[15px]">
                  <p>
                    The Bangladesh Foreign Trade Institute (BFTI) is a Ministry
                    of Commerce–affiliated think tank serving both public and
                    private sectors through research, policy advocacy, training,
                    and education to strengthen the country’s trade and business
                    environment.
                  </p>
                  <ul className="list-disc ms-5 mt-4">
                    <li>
                      This website is designed with Bootstrap and javaScript for
                      UI functionalities.
                    </li>
                    <li>This website is fully mobile responsive.</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="mt-10">
              <Link
                target="_blank"
                rel="noreferrer"
                to="https://bfti.netlify.app"
                className="text-teal-600 hover:text-teal-800 hover:underline me-3"
              >
                Go to BFTI Demo
              </Link>
              <Link
                target="_blank"
                rel="noreferrer"
                to="https://bfti.org.bd/"
                className="text-teal-600 hover:text-teal-800 hover:underline"
              >
                Go to BFTI
              </Link>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
